const Endpoints = {
  Auth: {
    AppRedirectLogin: '/api/auth/web-redirect-login',
  },
  Query: {
    GetAssets: '',
    GetChains: '/api/chain/get-all',
    GetMerchantList: '/api/merchant/get-all',
  },
  TransactionRequest: {
    GetAll: '/api/request-approval/get-all',
    Export: '/api/request-approval/export',
    GetApprovalHistory: '/api/request-approval/get-approval-list',
    Approve: '/api/request-approval/approve',
    Reject: '/api/request-approval/reject',
  },
} as const;

export default Endpoints;
